// Hook do tworzenia zadania – POST /sales-crm/tasks

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPostSalesCrmTaskRequest {
  name: string;
  due_date: string;
  priority: number | null;
  status: number | string;
  type: string | null;
  trader_id: number | null;
  client_id: number | null;
}

type IResponse = ICommandResponseSuccess;

const postSalesCrmTask = (data: IPostSalesCrmTaskRequest): Promise<IResponse> =>
  axios.post('/sales-crm/tasks', data);

export const usePostSalesCrmTask = (
  options?: UseMutationOptions<IResponse, IError, IPostSalesCrmTaskRequest>
) => useMutation((data: IPostSalesCrmTaskRequest) => postSalesCrmTask(data), options);
